<template>
  <card class="card" title="Agregar configuración">
    <div>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-12" v-if="role_admin">
            <!-- Estación -->
            <vSelect 
              :options="stations"
              placeholder="Selecciona una estación*"
              v-model="form.station_id"
              :class="{
               'is-invalid': submitted && $v.form.station_id.$error
              }"
              />
          </div>
          <div class="col-md-12" v-else>
            <div>
              <fg-input
                disabled
                type="text"
                v-model="stationName"
                :class="{
                'is-invalid': submitted && $v.form.name.$error
                }"
              >
              </fg-input>
            </div>
          </div>
        </div><br/> 

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Nombre Configuración*"
              placeholder="Nombre de la configuración"
              v-model="form.name"
              :class="{
               'is-invalid': submitted && $v.form.name.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.name.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.name.required"
                >Requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="date"
              label="Fecha inicio*"
              v-model="form.configuration_date"
              min="2018-01-01"
              :max='currentDate'
              :class="{
               'is-invalid': submitted && $v.form.configuration_date.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.configuration_date.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.configuration_date.required"
                >La fecha es requerida</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Usuario*"
              placeholder="Usuario*"
              v-model="form.username"
              :class="{
               'is-invalid': submitted && $v.form.username.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.username.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.username.required"
                >El usuario es requerido</span
              >
            </div>
          </div>
          <div class="col-md-6">
            <fg-input
              type="password"
              label="Contraseña*"
              placeholder="Contraseña"
              v-model="form.password"
              :class="{
               'is-invalid': submitted && $v.form.password.$error
              }"
            >
            </fg-input>
            <div
              v-if="submitted && $v.form.password.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.form.password.required"
                >La contraseña es requerida</span
              >
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <input
              type="checkbox"
              v-model="form.enabled"
            />
            <label class="label-check">Activo</label>
          </div>
        </div>

        <div><br/>
          <p-button 
            type="info" 
            @click.native.prevent="handleSubmit"
            style="margin-right: 10px;"
            >
            Enviar
          </p-button>
          <p-button type="danger" @click.native.prevent="handleCancel">
            Cancelar
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import configurationsService from '../../services/configurationsService';
import "vue-select/dist/vue-select.css";
import state from "../../store/state"
import vSelect from "vue-select";
import store from "../../store";
import { dateFormat } from "../../helpers";

const role = localStorage.getItem('role');

export default {
  components:{
    vSelect
  },
  data() {
    return {
      stations: [],
      form: {
        version: 0,
        station_id: { id: localStorage.getItem('stationId') },
        backedup_files: 0,
        username: localStorage.getItem('user'),
        name: "",
        password: "",
        configuration_date: "",
        enabled: false
      },
      role_admin: false,
      stationName: localStorage.getItem('stationName'),
      submitted: false,
      currentDate: dateFormat().toString()
    };
  },
  beforeCreate() {
    store.dispatch('actionGetStations');
  },
  mounted () {
    if (role === 'ADMIN' || role === 'SUPPORT') {
      this.stations = []
      if(
        localStorage.getItem('stationsJSON') &&
        JSON.parse(localStorage.getItem('stationsJSON')).length > 0
      ) {
          this.stations = localStorage.getItem('stationsJSON') 
            ? JSON.parse(localStorage.getItem('stationsJSON')) : []
      } else {
        setTimeout(() => {
          this.stations = state.stations.select
        }, 2000)
      }
      this.role_admin = true;
    } else {
      this.role_admin = false;
    }
  },
  validations: {
    form: {
      // station_id: { required }, 
      username: { required },
      name: { required },
      password: { required },
      configuration_date: { required }
    }
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      configurationsService.create({
        ...this.form,
        enabled: this.form.enabled ? 1 : 0
      }).then(response => {
        if(response.data.error === false) {
          swal({
            title: 'Exitoso', 
            text: 'La configuración se creo correctamente',
            icon: 'success', 
            timer: 3000, 
            buttons: false
          })
          setTimeout(()=> {
            this.$router.push('/descargar-tareas');
          }, 3000)
        } else {
          swal({
            title: '¡Algo salio mal!',
            text: 'Consulte con el administrador', 
            icon: 'warning', 
            timer: 3000, 
            buttons: false
          })
        }
      })
    },
    handleCancel() {
      swal({
        title: '¡Aviso!',
        text: 'Se perdera tu progreso actual',
        icon: 'warning',
        buttons: true,
      }).then((result) => {
        if (result) {
          this.$router.push("/descargar-tareas");
        }
      })
    }
  },
};
</script>
<style>
.label-check {
  margin-left:10px
}
</style>
